import React from "react";
import SidebarMenuItemDisplay from "../../Display/Menu/SidebarMenuItemDisplay";

const SidebarMenuItemContainer = (props) => {
  return <SidebarMenuItemDisplay {...props} />;
};

export default SidebarMenuItemContainer;
